"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionElement = function AccordionElement(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(_core.Accordion, null, /*#__PURE__*/React.createElement(_core.AccordionSummary, {
    expandIcon: item.i !== "step-0" && /*#__PURE__*/React.createElement(_ExpandMore.default, null),
    "aria-controls": "".concat(item.name, "-content"),
    id: "".concat(item.name, "-header"),
    disabled: true
  }, /*#__PURE__*/React.createElement(_core.Typography, null, item.label)));
};

var _default = AccordionElement;
exports.default = _default;